import styles from "../../constants/styles";
import BackToHomeButton from "../shared/BackToHomeButton";

const PrivacyPolicy = () => {
  return (
    <div className="flex flex-col items-start min-h-screen p-4 space-y-4">
      <BackToHomeButton />
      <h1 className={styles.secondaryHeading}>Privacy policy</h1>
      <p>
        Responsible person in terms of data protection laws, in particular the
        EU General Data Protection Regulation (GDPR), is:
      </p>
      <p>Fabian Rapp</p>
      <h2 className={styles.tertiaryHeading} id="your-data-subject-rights">
        Your data subject rights
      </h2>
      <p>
        You can exercise the following rights at any time using the contact
        details provided for our data protection officer:
      </p>
      <p>
        Information about your data stored by us and its processing (Art. 15
        GDPR),
      </p>
      <ul>
        <li>Correction of incorrect personal data (Art. 16 GDPR),</li>
        <li>Deletion of your data stored by us (Art. 17 GDPR),</li>
        <li>
          Restriction of data processing if we are not yet allowed to delete
          your data due to legal obligations (Art. 18 GDPR), objection to the
          processing of your data by us (Art. 21 GDPR) and
        </li>
        <li>
          Data portability, provided that you have consented to the data
          processing or have concluded a contract with us (Art. 20 GDPR).
        </li>
        <li>
          If you have given us consent, you can revoke it at any time with
          effect for the future.
        </li>
      </ul>
      <p>
        You may at any time lodge a complaint with a supervisory authority, e.g.
        the competent supervisory authority in the federal state of your
        residence or the authority responsible for us as the controller.
      </p>
      <p>
        A list of supervisory authorities (for the non-public sector) with
        address can be found at:{" "}
        <a href="https://www.bfdi.bund.de/DE/Service/Anschriften/Laender/Laender-node.html">
          https://www.bfdi.bund.de/DE/Service/Anschriften/Laender/Laender-node.html
        </a>
        .
      </p>
      <h2
        className={styles.tertiaryHeading}
        id="provision-of-chargeable-services-"
      >
        Provision of chargeable services.
      </h2>
      <h3 id="nature-and-purpose-of-processing-">
        Nature and purpose of processing:
      </h3>
      <p>
        For the provision of chargeable services, we request additional data,
        such as payment details, in order to be able to execute your order.
      </p>
      <h3 id="legal-basis-">Legal basis:</h3>
      <p>
        The processing of the data required for the conclusion of the contract
        is based on Art. 6 (1) lit. b GDPR.
      </p>
      <h3 id="recipients-">Recipients:</h3>
      <p>Recipients of the data are, if applicable, order processors.</p>
      <h3 id="third-country-transfer-">Third country transfer:</h3>
      <p>
        The collected data may be transferred to the following third countries:
      </p>
      <p>United States of America</p>
      <p>The following data protection guarantees are in place:</p>
      <p>Standard Contractual Clauses</p>
      <h3 id="storage-period-">Storage period:</h3>
      <p>
        We store this data in our systems until the statutory retention periods
        have expired. These are generally 6 or 10 years for reasons of proper
        recordkeeping and tax law requirements.
      </p>
      <h2
        className={styles.tertiaryHeading}
        id="provision-mandatory-or-required-"
      >
        Provision mandatory or required:
      </h2>
      <p>
        The provision of your personal data is voluntary. Without the provision
        of your personal data, we cannot grant you access to our offered content
        and services.
      </p>
      <h2
        className={styles.tertiaryHeading}
        id="use-of-script-libraries-google-web-fonts-"
      >
        Use of script libraries (Google Web Fonts).
      </h2>
      <p>
        In order to display our content correctly and graphically appealing
        across browsers, we use &quot;Google Web Fonts&quot; of Google LLC (1600
        Amphitheatre Parkway, Mountain View, CA 94043, USA; hereinafter
        &quot;Google&quot;) on this website to display fonts.
      </p>
      <p>
        Further information on Google Web Fonts can be found at{" "}
        <a href="https://developers.google.com/fonts/faq">
          https://developers.google.com/fonts/faq
        </a>{" "}
        and in Google&#39;s privacy policy:{" "}
        <a href="https://www.google.com/policies/privacy/">
          https://www.google.com/policies/privacy/
        </a>
        .
      </p>
      <h2 className={styles.tertiaryHeading} id="ssl-encryption">
        SSL encryption
      </h2>
      <p>
        To protect the security of your data during transmission, we use
        state-of-the-art encryption methods (e.g. SSL) via HTTPS.
      </p>
      <h2
        className={styles.tertiaryHeading}
        id="information-about-your-right-of-objection-according-to-art-21-gdpr"
      >
        Information about your right of objection according to Art. 21 GDPR
      </h2>
      <h3 id="individual-right-of-objection">Individual right of objection</h3>
      <p>
        You have the right to object at any time, on grounds relating to your
        particular situation, to the processing of personal data relating to you
        which is carried out on the basis of Art. 6(1)(f) GDPR (data processing
        on the basis of a balance of interests); this also applies to profiling
        based on this provision within the meaning of Art. 4 No. 4 GDPR.
      </p>
      <p>
        If you object, we will no longer process your personal data unless we
        can demonstrate compelling legitimate grounds for the processing which
        override your interests, rights and freedoms, or the processing serves
        the purpose of asserting, exercising or defending legal claims.
      </p>
      <h3 id="recipient-of-an-objection">Recipient of an objection</h3>
      <p>Fabian Rapp</p>
      <h2
        className={styles.tertiaryHeading}
        id="amendment-of-our-privacy-policy"
      >
        Amendment of our privacy policy
      </h2>
      <p>
        We reserve the right to adapt this privacy policy so that it always
        complies with the current legal requirements or to implement changes to
        our services in the privacy policy, e.g. when introducing new services.
        The new data protection statement will then apply to your next visit.
      </p>
      <h2
        className={styles.tertiaryHeading}
        id="questions-to-the-data-protection-officer"
      >
        Questions to the data protection officer
      </h2>
      <p>
        If you have any questions about data protection, please send us an
        e-mail or contact the person responsible for data protection in our
        organization directly.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
